<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h3>이용약관</h3>
        </div>

        <div class="section-body">
          <!--- agree1 -->
          <dl class="field-group vertical">
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                LG유플러스 서비스 이용 약관 동의<em class="primary-text">
                  (필수동의)</em
                >
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="requiredForUPlusService"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree2 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                개인정보 수집 이용 동의<em class="primary-text"> (필수동의)</em>
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="requiredForPersonalInformation"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree7 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                서비스 제공을 위한 개인정보 제공 이전 동의<em
                  class="primary-text"
                >
                  (필수동의)</em
                >
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="requiredForServiceProviding"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree11 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                신용정보 조회에 관한 동의<em class="primary-text">
                  (필수동의)</em
                >
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="requiredForCreditInformation"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree8 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                고객 혜택정보 제공을 위한 정보 수집 ·이용 동의
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="optionalMarketingOffer"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree10 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                혜택정보 · 광고 수신 동의
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="optionalMarketingOfferPersonal"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree9 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">광고전송동의 (선택동의)</h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="optionalMarketingOfferWay"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree10 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="optionalMarketingOfferPersonalTrst"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree3 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                번호 이동 신청 동의<em class="primary-text"> (필수동의)</em>
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="requiredForMobileMove"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree4 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                휴대폰 구입 비용 지원 신청 동의<em class="primary-text">
                  (필수동의)</em
                >
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="requiredForMobileFeeSupport"
                />
              </div>
            </dd>
          </dl>

          <dl class="field-group vertical">
            <!--- agree5 -->
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
                휴대폰 할부계약 약정조항<em class="primary-text">
                  (필수동의)</em
                >
              </h4>
            </dt>
            <dd class="field-control wfull">
              <div class="field-control-sub text-detail scrollable">
                <p
                  role="region"
                  tabindex="0"
                  class="td-term"
                  v-html="requiredForMobileInstallment"
                />
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpenMarketTerms',

  props: {},

  data() {
    return {}
  },

  computed: {
    reqTermConditionList() {
      return this.termConditionList.filter(i => i.req)
    },
    optTermConditionList() {
      return this.termConditionList.filter(i => !i.req)
    },

    requiredForUPlusService() {
      let fileName = 'agree1.html'
      if (this.isConciergeDevice) {
        fileName = 'agree1_cdevice.html'
      }

      return require('html-loader!~/html/appl/' + fileName)
    },
    requiredForConciergeDeviceOnlyOneInformation() {
      return require('html-loader!~/html/appl/agree2_cdevice.html')
    },
    requiredForPersonalInformation() {
      let fileName = 'agree2.html'
      if (this.isNote7) fileName = 'agree2_SM_N930L.html'
      return require('html-loader!~/html/appl/' + fileName)
    },
    requiredForServiceProviding() {
      return require('html-loader!~/html/appl/agree7.html')
    },
    requiredForCreditInformation() {
      let fileName = 'agree11.html'
      if (this.isConciergeDevice) fileName = 'agree3_cdevice.html'
      return require('html-loader!~/html/appl/' + fileName)
    },
    requiredForConciergeDeviceSaleUse() {
      //  컨시어지 디바이스 용 약관동의 ~/html/appl/agree4_cdevice.html
      return require('html-loader!~/html/appl/agree4_cdevice.html')
    },
    optionalMarketingOffer() {
      //  고객 혜택정보/광고 정보 제공을 위한 동의(선택동의) =>24.05.02 고객 혜택정보 제공을 위한 정보 수집 ·이용 동의 
      return require('html-loader!~/html/appl/agree8.html')
    },
    optionalMarketingOfferWay() {
      //  광고전송동의(선택동의)
      return require('html-loader!~/html/appl/agree9.html')
    },
    optionalMarketingOfferPersonal() {
      // 위치기반 정보제공 및 광고전송 서비스 동의 (마케팅 활용동의)(선택) =>24.05.02 혜택정보 · 광고 수신 동의  
      return require('html-loader!~/html/appl/agree10.html')
    },
    optionalMarketingOfferPersonalTrst() {
      // 24.05.02 고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내
      return require('html-loader!~/html/appl/agree16.html')
    },    
    requiredForMobileRouter() {
      //  모바일라우터 의무약정 조항(필수동의)
      return require('html-loader!~/html/appl/agree5_router.html')
    },
    requiredForMobileMove() {
      //  번호 이동 신청 동의(필수동의)
      return require('html-loader!~/html/appl/agree3.html')
    },
    requiredForMobileFeeSupport() {
      //  휴대폰 구입 비용 지원 신청 동의(필수동의)
      return require('html-loader!~/html/appl/agree4.html')
    },
    requiredForConciergeDeviceInstallment() {
      //  컨시어지 디바이스 용 약관동의
      return require('html-loader!~/html/appl/agree5_cdevice.html')
    },
    requiredForMobileInstallment() {
      // 휴대폰 할부계약 약정조항(필수동의)
      return require('html-loader!~/html/appl/agree5.html')
    },
    requiredForLocationServiceInformationOffer() {
      // 위치 기반 서비스 정보 제공 및 동의 (필수동의)
      return require('html-loader!~/html/appl/agree6_cdevice.html')
    },
    requiredForAsianaMileage() {
      // 개인정보 수집 이용 동의서(사은품 발송 및 경품행사용)
      return require('html-loader!~/html/appl/agree_asiana.html')
    }
  },

  methods: {}
}
</script>

<style scoped></style>
